import {Component, OnInit} from '@angular/core';
import {Document} from '../documents/document-countries/document-countries.component';

@Component({
  selector: 'app-license-agreement',
  templateUrl: './license-agreement.component.html',
})
export class LicenseAgreementComponent implements OnInit {
  countries: Array<Document> = [
    {
      countryName: 'Россия',
      img: 'ru.svg',
      docHref: 'license-agreement.html'
    },
    {
      countryName: 'Казахстан',
      img: 'kz.svg',
      docHref: 'license-agreement-kz.html'
    },
    {
      countryName: 'Кыргызстан',
      img: 'kg.svg',
      docHref: 'license-agreement-kg.html'
    },
    {
      countryName: 'Беларусь',
      img: 'by.svg',
      docHref: 'license-agreement-by.html'
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

}
